import { Injectable } from '@angular/core';

import { EntityService } from '@vshosting/core';
import { CdnNodeTaskQueueConsolidated } from "@vshosting/models";
import { ApiEntityKeys } from '../../app.constant';

@Injectable({ providedIn: 'root' })
export class NodeTaskQueueConsolidatedEntity extends EntityService<CdnNodeTaskQueueConsolidated> {
  constructor() {
    super(ApiEntityKeys.NodeTaskQueueConsolidated);
  }
}
